const types = {
  SET_KEYWORD: "SET_KEYWORD",
  SET_INGREDIENT: "SET_INGREDIENT",
  ADD_INGREDIENT: "ADD_INGREDIENT",
  SET_RECIPES_WITH_DETAILS: "SET_RECIPES_WITH_DETAILS",
  REMOVE_INGREDIENT: "REMOVE_INGREDIENT",
  SHOW_LOADER: "SHOW_LOADER",
  NO_RECIPES_FOUND: "NO_RECIPES_FOUND",
  SHOW_ERROR: "SHOW_ERROR",
  CLEAR_ERROR: "CLEAR_ERROR",
  IS_RECIPES_MODAL_OPEN: "IS_RECIPES_MODAL_OPEN",
};

export default types;
